import type { PickupPointLocation } from 'services';

export function doesPickupPointMatchQuery(location: PickupPointLocation, query: string): boolean {
  const normalizedQuery = query.trim().toLocaleLowerCase();

  return [location.name, location.address, location.city, location.zip].some(value =>
    String(value ?? '')
      .toLocaleLowerCase()
      .includes(normalizedQuery)
  );
}
